var map = {
	"./icon_rating_happy1.webp": 36156,
	"./icon_rating_happy2.webp": 95545,
	"./icon_rating_sad1.webp": 19474,
	"./icon_rating_sad2.webp": 53747,
	"./icon_rating_veryhappy1.webp": 15968,
	"./icon_rating_veryhappy2.webp": 89677,
	"./icon_rating_verysad1.webp": 53486,
	"./icon_rating_verysad2.webp": 85935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44098;